import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import CountryDTO from "../interfaces/ip-country-dto";

@Injectable({
  providedIn: 'root'
})
export class IpCountryService {
  api = environment.api;

  constructor(private http: HttpClient) { }

  getCountryById(id: number) {
    return this.http.get<CountryDTO>(`${this.api}/invopay/countries/${id}`);
  }
  
  getEnterpriseCountry() {
    return this.http.get<CountryDTO>(`${this.api}/invopay/countries/enterpriseCountry`);
  }
}
